import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Wrapper from '../../components/wrapper'
import CarLineupFilterItem from '../car-lineup-filter-item'
import './styles.css'

/**
 *  CarLineupFilter
 */
class CarLineupFilter extends PureComponent {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    bodyType: PropTypes.shape({
      title: PropTypes.string,
      filterItems: PropTypes.array
    }),
    engineType: PropTypes.shape({
      title: PropTypes.string,
      filterItems: PropTypes.array
    }),
    mission: PropTypes.shape({
      title: PropTypes.string,
      filterItems: PropTypes.array
    }),
    drive: PropTypes.shape({
      title: PropTypes.string,
      filterItems: PropTypes.array
    }),
    capacity: PropTypes.shape({
      title: PropTypes.string,
      filterItems: PropTypes.array
    }),
    price: PropTypes.shape({
      title: PropTypes.string,
      filterItems: PropTypes.array
    }),
    displacement: PropTypes.shape({
      title: PropTypes.string,
      minFilterItems: PropTypes.array,
      maxFilterItems: PropTypes.array
    }),
    bodySize: PropTypes.shape({
      title: PropTypes.string,
      lengthTitle: PropTypes.string,
      lengthFilterItems: PropTypes.array,
      widthTitle: PropTypes.string,
      widthFilterItems: PropTypes.array,
      heightTitle: PropTypes.string,
      heightFilterItems: PropTypes.array
    }),
    others: PropTypes.shape({
      title: PropTypes.string,
      svTitle: PropTypes.string,
      svFilterItems: PropTypes.array,
      supportCarTitle: PropTypes.string,
      supportCarFilterItems: PropTypes.array,
      ecoTaxTitle: PropTypes.string,
      ecoTaxFilterItems: PropTypes.array,
      subsidyTitle: PropTypes.string,
      subsidyFilterItems: PropTypes.array
    })
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    bodyType: null,
    engineType: null,
    mission: null,
    drive: null,
    capacity: null,
    price: null,
    displacement: null,
    bodySize: null,
    others: null
  };

  constructor(props) {
    super()
    this.props = props
    this.state = {}
  }

  render() {
    const {
      containerId,
      containerClass,
      bodyType,
      engineType,
      mission,
      drive,
      capacity,
      price,
      displacement,
      bodySize,
      others
    } = this.props

    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}>
        <div className="CarLineupFilter">
          <div className="CarLineupFilter__Column CarLineupFilter__Column--bodyType">
            <div className="CarLineupFilter__Column__Title">{bodyType.title}</div>
            <ul className="CarLineupFilter__Column__List">
              {
                bodyType.filterItems.map((data, index) => {
                  const props = Object.assign({}, data.props)
                  return (
                    <li className="CarLineupFilter__Column__List__Item" key={index}>
                      <CarLineupFilterItem
                        {...props}
                        formType="radio"
                        formName="bodyType"
                        key={index} />
                    </li>
                  )
                })
              }
            </ul>
          </div>
          <div className="CarLineupFilter__Column CarLineupFilter__Column--engineType">
            <div className="CarLineupFilter__Column__Title">{engineType.title}</div>
            <ul className="CarLineupFilter__Column__List">
              {
                engineType.filterItems.map((data, index) => {
                  const props = Object.assign({}, data.props)
                  return (
                    <li className="CarLineupFilter__Column__List__Item" key={index}>
                      <CarLineupFilterItem
                        {...props}
                        formType="radio"
                        formName="engineType"
                        key={index} />
                    </li>
                  )
                })
              }
            </ul>
          </div>
          <div className="CarLineupFilter__Column CarLineupFilter__Column--mission">
            <div className="CarLineupFilter__Column__Title">{mission.title}</div>
            <ul className="CarLineupFilter__Column__List">
              {
                mission.filterItems.map((data, index) => {
                  const props = Object.assign({}, data.props)
                  return (
                    <li key={index} className="CarLineupFilter__Column__List__Item">
                      <CarLineupFilterItem
                        {...props}
                        formType="radio"
                        formName="mission"
                        key={index} />
                    </li>
                  )
                })
              }
            </ul>
          </div>
          <div className="CarLineupFilter__Column CarLineupFilter__Column--drive">
            <div className="CarLineupFilter__Column__Title">{drive.title}</div>
            <ul className="CarLineupFilter__Column__List">
              {
                drive.filterItems.map((data, index) => {
                  const props = Object.assign({}, data.props)
                  return (
                    <li key={index} className="CarLineupFilter__Column__List__Item">
                      <CarLineupFilterItem
                        {...props}
                        formType="radio"
                        formName="drive"
                        key={index} />
                    </li>
                  )
                })
              }
            </ul>
          </div>
          <div className="CarLineupFilter__Column CarLineupFilter__Column--capacity">
            <div className="CarLineupFilter__Column__Title">{capacity.title}</div>
            <ul className="CarLineupFilter__Column__List">
              {
                capacity.filterItems.map((data, index) => {
                  const props = Object.assign({}, data.props)
                  return (
                    <li key={index} className="CarLineupFilter__Column__List__Item">
                      <CarLineupFilterItem
                        {...props}
                        formType="radio"
                        formName="capacity"
                        key={index} />
                    </li>
                  )
                })
              }
            </ul>
          </div>

          <div className="CarLineupFilter__Column CarLineupFilter__Column--price-displacement">
            <div className="CarLineupFilter__Column CarLineupFilter__Column--price">
              <div className="CarLineupFilter__Column__Title">{price.title}</div>
              <select name="price" className="CarLineupFilter__Column__Select">
                {
                  price.filterItems.map((data, index) => {
                    const props = Object.assign({}, data.props)
                    return (
                      <CarLineupFilterItem
                        {...props}
                        formType="option"
                        formName="price"
                        key={index} />
                    )
                  })
                }
              </select>
            </div>
            <div className="CarLineupFilter__Column CarLineupFilter__Column--displacement">
              <div className="CarLineupFilter__Column__Title">{displacement.title}</div>
              <div className="CarLineupFilter__Column__Container">
                <select name="minDisplacement" className="CarLineupFilter__Column__Select">
                  {
                    displacement.minFilterItems.map((data, index) => {
                      const props = Object.assign({}, data.props)
                      return (
                        <CarLineupFilterItem
                          {...props}
                          formType="option"
                          formName="minDisplacement"
                          key={index} />
                      )
                    })
                  }
                </select>
                <span className="CarLineupFilter__Column--displacement__range">〜</span>
                <select name="maxDisplacement" className="CarLineupFilter__Column__Select">
                  {
                    displacement.maxFilterItems.map((data, index) => {
                      const props = Object.assign({}, data.props)
                      return (
                        <CarLineupFilterItem
                          {...props}
                          formType="option"
                          formName="maxDisplacement"
                          key={index} />
                      )
                    })
                  }
                </select>
              </div>
            </div>
          </div>

          <div className="CarLineupFilter__Column CarLineupFilter__Column--bodySize">
            <div className="CarLineupFilter__Column__Title">{bodySize.title}</div>
            <div className="CarLineupFilter__Column__Container">
              <div className="CarLineupFilter__Column__FormTitle">{bodySize.lengthTitle}</div>
              <select name="bodySizeLength" className="CarLineupFilter__Column__Select">
                {
                  bodySize.lengthFilterItems.map((data, index) => {
                    const props = Object.assign({}, data.props)
                    return (
                      <CarLineupFilterItem
                        {...props}
                        formType="option"
                        formName="bodySizeLength"
                        key={index} />
                    )
                  })
                }
              </select>
            </div>
            <div className="CarLineupFilter__Column__Container">
              <div className="CarLineupFilter__Column__FormTitle">{bodySize.widthTitle}</div>
              <select name="bodySizeWidth" className="CarLineupFilter__Column__Select">
                {
                  bodySize.widthFilterItems.map((data, index) => {
                    const props = Object.assign({}, data.props)
                    return (
                      <CarLineupFilterItem
                        {...props}
                        formType="option"
                        formName="bodySizeWidth"
                        key={index} />
                    )
                  })
                }
              </select>
            </div>
            <div className="CarLineupFilter__Column__Container">
              <div className="CarLineupFilter__Column__FormTitle">{bodySize.heightTitle}</div>
              <select name="bodySizeHeight" className="CarLineupFilter__Column__Select">
                {
                  bodySize.heightFilterItems.map((data, index) => {
                    const props = Object.assign({}, data.props)
                    return (
                      <CarLineupFilterItem
                        {...props}
                        formType="option"
                        formName="bodySizeHeight"
                        key={index} />
                    )
                  })
                }
              </select>
            </div>
          </div>
          <div className="CarLineupFilter__Column CarLineupFilter__Column--others">
            <div className="CarLineupFilter__Column__Title">{others.title}</div>
            <ul className="CarLineupFilter__Column__List">
              {
                others.kankyowariFilterItems ?
                  others.kankyowariFilterItems.map((data, index) => {
                    const props = Object.assign({}, data.props)
                    return (
                      <li key={index} className="CarLineupFilter__Column__List__Item">
                        <CarLineupFilterItem
                          {...props}
                          formType="checkbox"
                          formName="othersKankyowari"
                          key={index} />
                      </li>
                    )
                  })
                  : null
              }
              {
                others.svFilterItems ?
                  others.svFilterItems.map((data, index) => {
                    const props = Object.assign({}, data.props)
                    return (
                      <li key={index} className="CarLineupFilter__Column__List__Item">
                        <CarLineupFilterItem
                          {...props}
                          formType="checkbox"
                          formName="othersSv"
                          key={index} />
                      </li>
                    )
                  })
                  : null
              }
              {
                others.supportCarFilterItems ?
                  others.supportCarFilterItems.map((data, index) => {
                    const props = Object.assign({}, data.props)
                    return (
                      <li key={index} className="CarLineupFilter__Column__List__Item">
                        <CarLineupFilterItem
                          {...props}
                          formType="checkbox"
                          formName="othersSupportCar"
                          key={index} />
                      </li>
                    )
                  })
                  : null
              }
              {
                others.ecoTaxFilterItems ?
                  others.ecoTaxFilterItems.map((data, index) => {
                    const props = Object.assign({}, data.props)
                    return (
                      <li key={index} className="CarLineupFilter__Column__List__Item">
                        <CarLineupFilterItem
                          {...props}
                          formType="checkbox"
                          formName="othersEcoTax"
                          key={index} />
                      </li>
                    )
                  })
                  : null
              }
              {
                others.subsidyFilterItems ?
                  others.subsidyFilterItems.map((data, index) => {
                    const props = Object.assign({}, data.props)
                    return (
                      <li key={index} className="CarLineupFilter__Column__List__Item">
                        <CarLineupFilterItem
                          {...props}
                          formType="checkbox"
                          formName="othersSubsidy"
                          key={index} />
                      </li>
                    )
                  })
                  : null
              }
            </ul>
          </div>
        </div>
      </Wrapper>
    )
  }
}

export default CarLineupFilter



// WEBPACK FOOTER //
// ./src/containers/car-lineup-filter/index.jsx